export default __webpack_public_path__ + "static/media/title-ellipses.a3727f9b.svg";